module.exports = __webpack_public_path__ + "static/hero-2-ddd27b83161151947732c74564119e33.png";